/** Shared listing-hub chrome — aesthetic only; copy stays on each page. */
export const articleHub = {
    page: 'flex min-h-screen flex-col bg-article-cream font-archivo text-article-fg antialiased',
    main: 'mx-auto w-full max-w-article-hub flex-1 px-[clamp(18px,5vw,40px)] pb-14 pt-24 md:px-10 md:pb-20 md:pt-28',
    header: 'mb-10 flex flex-col gap-3.5 md:mb-12 md:flex-row md:items-end md:justify-between md:gap-10',
    headerCopy: 'flex min-w-0 flex-col gap-2.5',
    eyebrow: 'text-xs font-bold uppercase tracking-[0.14em] text-article-flame',
    title: 'm-0 max-w-[22ch] text-[clamp(34px,5.4vw,64px)] font-extrabold leading-[0.96] tracking-[-0.035em] text-article-fg',
    intro: 'm-0 max-w-[34ch] text-[clamp(16px,1.5vw,20px)] font-medium leading-[1.45] text-article-muted md:pb-0.5',
    tabs: 'mb-8 flex flex-wrap gap-2 md:mb-10',
    tabActive:
        'rounded-full bg-article-flame px-4 py-2 text-sm font-semibold text-white no-underline transition-colors',
    tabInactive:
        'rounded-full border border-article-border bg-transparent px-4 py-2 text-sm font-semibold text-article-fg no-underline transition-colors hover:border-article-flame hover:text-article-flame',
    leadItem: 'col-span-full mb-[clamp(8px,1.6vw,10px)]',
    grid: 'm-0 grid list-none grid-cols-1 gap-[clamp(20px,2.4vw,30px)] p-0 sm:grid-cols-2 lg:grid-cols-3',
} as const
